import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ImageType } from "../../../assets";
// import Card from "../../../components/card/Card";
import DashHeader from "../../../components/dashHeader/DashHeader";
import { logout } from "../../../redux/slices/authSlice";
import { AppDispatch, RootState } from "../../../redux/store";
import toast from "react-hot-toast";
import { getAuthTokenData } from "../../../utils/tokenUtils";
import Modal from "../../../components/modal/Modal";
import Form from "../../../components/form/Form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  UpdateAdminForm,
  updateAdminSchema,
} from "../../../constants/yup.schema";
import { UPDATE_ADMIN_FORM } from "../../../constants/update.admin.constants";
import {
  createAdminUser,
  deleteAdminUser,
  getAdminData,
  updateAdminData,
} from "../../../redux/slices/adminSlice";
import { roles } from "../../../constants/constants";
import { Card } from "@/components/ui/card";
import { getRandomAvatar } from "utils/randomAvatar";
import { Button } from "@/components/ui/button";
import CredCard from "@/components/StatsCard/CredsCard";
import AddAdminUser from "./AddAdminUser";

const Profile: React.FC = () => {
  const { userId, name, role, username } = getAuthTokenData();
  const navigate = useNavigate();
  const avatar = getRandomAvatar();
  const dispatch = useDispatch<AppDispatch>();
  const { adminData, loading } = useSelector((state: RootState) => state.admin);
  useEffect(() => {
    dispatch(getAdminData(userId));
  }, [userId]);

  const handleLogout = () => {
    dispatch(logout());
    toast.success("Logged out successfully");
    navigate("/auth/login");
  };

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const handleModal = () => setIsModalOpen(!isModalOpen);

  const {
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(updateAdminSchema),
    defaultValues: {
      name: adminData?.name || "",
      phone: adminData?.contactInfo?.phone || "",
      email: adminData?.contactInfo?.email || "",
      username: adminData?.username || "",
      // image: undefined,
      currentPassword: "",
      newPassword: "",
    },
  });

  const defaultValues = useRef({
    name: adminData?.name || "",
    phone: adminData?.contactInfo?.phone || "",
    email: adminData?.contactInfo?.email || "",
    username: adminData?.username || "",
    // image: undefined,
    currentPassword: "",
    newPassword: "",
  });

  const methods = useForm<UpdateAdminForm>({
    defaultValues: defaultValues.current,
    resolver: yupResolver(updateAdminSchema),
  });

  const {
    handleSubmit,
    reset: handleReset,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    if (adminData) {
      handleReset({
        name: adminData?.name || "",
        phone: adminData?.contactInfo?.phone || "",
        email: adminData?.contactInfo?.email || "",
        username: adminData?.username || "",
        currentPassword: "",
        newPassword: "",
      });
    }
  }, [adminData, handleReset]);

  const onSubmit = async (data: any) => {
    try {
      if (data.currentPassword && !data.newPassword) {
        toast.error(
          "New password is required when current password is provided."
        );
        return;
      }

      if (data.newPassword && data.currentPassword === data.newPassword) {
        toast.error("New password cannot be the same as the current password.");
        return;
      }

      await dispatch(updateAdminData(data));
      handleReset();
      dispatch(getAdminData(userId));
      handleModal();
    } catch (error) {
      toast.error("Failed to update profile.");
    }
  };
  // const handleAddNewUser = async () => {
  //   try {
  //     await dispatch(createAdminUser({ adminId: userId, username: "test3", plainTextPassword: "test3" }));
  //     dispatch(getAdminData(userId));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleDeleteUser = async (item: any) => {
    try {
      await dispatch(deleteAdminUser({ adminId: userId, username: item.username }));
      dispatch(getAdminData(userId));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <DashHeader title="Profile" />
      {loading ? (
        <div className="mt-10 w-full text-center">
          <div className="border-t-4 border-blue-500 border-solid rounded-full w-16 h-16 animate-spin mx-auto"></div>
        </div>
      ) : (
        <>
          <Card className=" bg-white rounded-lg p-4 w-full">
            <div className="flex justify-between p-6">
              <div className="flex items-center space-x-2 gap-10">
                <div className="">
                  <img
                    className="h-32 w-32 rounded-full"
                    src={adminData?.profilePicture || avatar}
                    alt="Avatar"
                  />
                </div>
                <div className="flex flex-col">
                  <h3 className="text-xl text-black font-bold leading-none ">Name:<span className="text-neutral-500 "> {adminData?.name || name} </span></h3>
                  <div className="text-xl text-black font-bold leading-none ">Email:<span className="text-neutral-500 "> {adminData?.contactInfo?.email}</span></div>
                  <div className="text-xl text-black font-bold leading-none ">Phone:<span className="text-neutral-500 "> {adminData?.contactInfo?.phone}</span></div>
                  <div className="text-xl text-black font-bold leading-none ">Licenses:<span className="text-neutral-500 "> {adminData?.licenses}</span></div>
                </div>
              </div>
              <div className="flex flex-col gap-4 mt-4">
                <Button onClick={handleModal} >
                  Edit Profile
                </Button>
                <Button onClick={handleLogout} variant={"destructive"} >
                  Log Out
                </Button>
              </div>
            </div>
          </Card>
          <div className="my-6 flex flex-col gap-2 bg-light_gray rounded-lg">
            <div className=" p-6">
              {/* <Button onClick={handleAddNewUser} variant={"secondary"} className="float-right">
                Add New User
              </Button> */}
              <AddAdminUser />
            </div>
            {

              adminData?.adminUsers?.map((item: any, i: number) => {
                if (i === 0) return null; // Skip the first element
                return (
                  <React.Fragment key={i}>
                    <CredCard key={i} username={item.username} plainTextPassword={item.plainTextPassword} onClick={() => handleDeleteUser(item)} />
                  </React.Fragment>
                );
              })
              // <SetTable data={adminData?.adminUsers} tableKeys={adminUsertableKeys} />
            }
          </div>
        </>
      )}
      <Modal
        isModalOpen={isModalOpen}
        onClick={handleModal}
        title="Update Profile"
      >
        <Form
          fields={UPDATE_ADMIN_FORM}
          control={control}
          method={methods}
          onClick={handleSubmit(onSubmit)}
          errors={errors}
          isSubmitting={isSubmitting}
          style="grid grid-cols-2 gap-4"
        />
      </Modal>
    </>
  );
};

export default Profile;
